<template>
  <div>
    <a-card style="border: none; border-radius: 12px">
      <div slot="title">
        <a-row type="flex" align="middle" justify="space-between">
          <a-col>
            <div class="title_h" v-if="ing == 1">
              开始培训 /
              <span>答题器检测</span>
            </div>
            <div class="title_h" v-if="ing == 2">
              开始培训 / 答题器检测 /
              <span>人员录入</span>
            </div>
            <div class="title_h" v-if="ing == 3">
              开始培训 / 答题器检测 / 人员录入 /
              <span>开始培训</span>
            </div>
            <div class="title_h" v-if="ing == 4">
              开始培训 / 答题器检测 / 人员录入 / 开始培训 /
              <span>开始考试</span>
            </div>
          </a-col>
          <a-col v-if="ing == 4">
            <a-space align="center">
              <FormItem label="倒计时:">
                <a-input
                  style="height: 100%"
                  type="number"
                  v-model="timeout"
                  placeholder="请输入倒计时"
                  suffix="秒"
                  @blur="blurTimeout"
                >
                </a-input>
              </FormItem>
              <a-button
                type="link"
                style="color: red"
                @click="showGameOver"
                v-if="is_over"
                >查看培训结果</a-button
              >
            </a-space>
          </a-col>
        </a-row>
      </div>
      <div style="min-height: calc(100vh - 100px - 160px)">
        <!-- 检测失败开始 -->
        <Procedure1
          ref="procedure1"
          v-if="ing == 1"
          :isSign="isSign"
          :refashVoteLoading="refashVoteLoading"
          @refashVote="refashVote"
          :controlRot="controlRot"
          :sInfo="sInfo"
          @signOut="signOut"
          @readIdcard="readIdcard"
          :jianceSelectFlag="jianceSelectFlag"
          :jianceSelectType="jianceSelectType"
          @signNext="signNext"
        ></Procedure1>
        <!-- 检测失败结束 -->
        <!-- 检测中开始 -->
        <Procedure2
          v-if="ing == 2"
          ref="procedure2"
          :controlRot="controlRot"
          @deleteControlRot="deleteControlRot"
          @goTrain="goTrain"
        ></Procedure2>
        <!-- 检测中结束 -->
        <!-- 开始培训开始 -->
        <Procedure3
          v-if="ing == 3"
          :classesData="classesData"
          :name="name"
          @goExamination="goExamination"
          :topicsData="topicsData"
          :bad="bad"
          :good="good"
          @startStudy="startStudy"
          @addStudyClass="addStudyClass"
        ></Procedure3>
        <!-- 开始培训结束 -->
        <!-- 开始考试开始 -->
        <Procedure4
          v-show="ing == 4"
          ref="procedure4"
          :topicsData="topicsData"
          :controlRot="controlRot"
          :index="index"
          :timeout="timeout"
          @overonce="overonce"
          @startExam="startExam"
        ></Procedure4>
        <!-- 开始考试结束 -->
      </div>
    </a-card>
    <Gameover
      ref="gameover"
      :controlRot="controlRot"
      :studyTime="studyTime"
      :examTime="examTime"
      :bad="bad"
      :name="name"
      :overloading="overloading"
      @signCallback="signCallback"
      @sendOver="sendOver"
    ></Gameover>
  </div>
</template>

<script>
import Procedure1 from "./trainPlayComponents/procedure1";
import Procedure2 from "./trainPlayComponents/procedure2";
import Procedure3 from "./trainPlayComponents/procedure3";
import Procedure4 from "./trainPlayComponents/procedure4";
import Gameover from "./trainPlayComponents/gameover";
import { trainProgramInfo, examOver } from "@/request/classes";
import SunVote from "@/utils/SunVote";
import CardSocketClient from "@/utils/idcard";
import FormItem from "@/components/FormItem/index";
import { personIdinfo } from "@/request/person";
export default {
  components: {
    Procedure1,
    Procedure2,
    Procedure3,
    Procedure4,
    FormItem,
    Gameover,
  },
  data() {
    return {
      ing: 1,
      id: "",
      name: "", //培训方案名称
      classesData: [], //课程
      topicsData: [], //题目
      studyClass: [], //已学习了的课程
      index: -1, //当前第几题
      bad: 0, //不及格分数
      good: "", //优秀，绿码分数
      principal: "", //培训负责人
      jyr1: "",
      jyr2: "",
      jyr3: "",
      SunVote: null,
      refashVoteLoading: false,
      Mode2: 1, //提交后是否可修改 0不能1能
      sInfo: 0, //是否连接 0还未连接或正在连接 “1”基站连接成功 “2”基站连接失败或已断开
      controlRot: [
        // {
        //   iKeyID: 10,
        //   sKeySN: "1",
        //   person_id: "",
        //   id_no: "",
        //   score: 85,
        //   name: "",
        //   result: [],
        //   sign: "",
        //   finger: "",
        // },
      ], //已经读取或签到得遥控器数据
      isSign: true, //是否正在签到
      jianceSelectFlag: false, //是否已选择录入方式
      jianceSelectType: "", //1身份证2人脸
      client: null,
      studyTime: null, //开始培训的时间戳
      examTime: null, //开始考试的时间戳
      timeout: 30, //一题的默认答题时间
      is_over: false, //是否已经考试完毕
      overloading: false, //最后的数据发送按钮的loading
      showIdCLose: null,
    };
  },
  created() {
    console.log(this.$route.query.id);
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getInfo();
    }
  },
  beforeDestroy() {
    if (this.client) {
      this.client.close();
      this.client = null;
    }
    if (this.SunVote) {
      this.SunVote.Disconnect();
    }
  },
  mounted() {
    if (this.ing == 1) this.connectVote();
  },
  methods: {
    //查看了某个课程
    addStudyClass(e) {
      const index = this.studyClass.findIndex((v) => v.id == e.id);
      if (index == -1) {
        this.studyClass.push(e);
      }
    },
    //修改答题倒计时
    blurTimeout() {
      this.$notification["success"]({
        message: "修改答题倒计时成功",
        description: "将在下一题开始生效",
      });
    },
    //连接失败用户主动点击刷新重连基站
    refashVote() {
      this.refashVoteLoading = true;
      this.SunVote.Connect();
    },
    //初始化连接基站等操作
    connectVote() {
      this.refashVoteLoading = true;
      this.SunVote = new SunVote(1);
      this.SunVote.setOwnConnectEventCallBack((iBaseID, iMode, sInfo) => {
        this.refashVoteLoading = false;
        this.sInfo = sInfo;
        // console.log(iBaseID, iMode, sInfo);
        if (sInfo == 1) {
          this.$message.success("答题设备连接成功");
          // if (this.controlRot.length == 0) this.signIn();
          this.signIn();
        } else {
          this.$message.error("答题设备连接失败或已断开");
        }
      });
      this.SunVote.setOwnErrorCallback((e) => {
        this.$message.error(e.message);
      });
      this.SunVote.setOwnKeyEventCallBack(
        (iBaseID, iKeyID, sKeySN, iMode, Time, sInfo) => {
          // console.log("收到回调", iBaseID, iKeyID, sKeySN, iMode, Time, sInfo);
          //签到
          // if (iMode == this.SunVote.iModeType["VoteType_Signin"]) {
          if (this.ing == 1) {
            const index = this.controlRot.findIndex((v) => v.iKeyID == iKeyID);
            if (index == -1) {
              this.$notification["success"]({
                message: "检测成功一个答题器",
                description: `成功检测到${iKeyID}号答题器`,
                duration: 1.5,
              });
              this.controlRot.unshift({
                iKeyID: iKeyID,
                sKeySN: sKeySN,
                person_id: "",
                id_no: "",
                name: "",
                result: [],
                score: 0,
                sign: "",
                finger: "",
              });
            }
          } else {
            //答题按键结果
            const index = this.controlRot.findIndex((v) => v.iKeyID == iKeyID);
            if (index > -1) {
              this.$nextTick(() => {
                this.controlRot[index].result[this.index].myanswer = sInfo;
              });
            }
          }
        }
      );
      this.SunVote.Connect();
    },
    //答题器设备签到
    signIn() {
      this.isSign = true;
      this.SunVote.VoteStart2("VoteType_Signin", "1");
    },
    /**
     * 发送开始答题指令
     * @param {*} type 类型1单选2判断3多选
     */
    startGame(type) {
      this.SunVote.VoteStart2(
        "VoteType_Choice",
        `1,${this.Mode2},0,0,${type == 2 ? 2 : 4},${type == 3 ? 4 : 1}`
      );
    },
    //退出签到开始录入人员信息
    signOut() {
      if (this.controlRot.length == 0) {
        return this.$error({
          centered: true,
          title: "操作失败",
          content: "至少需要识别一个答题器",
          getContainer: () => document.getElementById("bodyContnet"),
        });
      }
      if (this.jianceSelectFlag || !this.isSign) {
        return (this.$refs.procedure1.jianceSelect = true);
      }
      this.$confirm({
        centered: true,
        title: "再次确认",
        content: "答题器是否已全部检测完成，【确认】后将无法再检测答题器",
        okText: "确认",
        cancelText: "取消",
        getContainer: () => document.getElementById("bodyContnet"),
        onOk: () => {
          this.SunVote.VoteStop2();
          this.isSign = false;
          this.$refs.procedure1.jianceSelect = true;
          this.$refs.procedure1.readIdcard(1);
        },
      });
    },
    //身份证读取
    readIdcard(type) {
      this.jianceSelectFlag = true;
      this.jianceSelectType = type;
      this.client = new CardSocketClient();
      this.client.connect();
      // 设置回调函数来处理收到的消息
      this.client.setDataCallback((res) => {
        personIdinfo({ id_no: res.IDNumber }).then((re) => {
          if (!!re.data) {
            //是否存在当前刷的身份证人
            const personIndex = this.controlRot.findIndex(
              (v) => v.id_no == res.IDNumber
            );
            if (personIndex > -1)
              return this.$message.error(`【${res.Name}】已经录入过了`);
            const index = this.controlRot.findIndex((v) => v.id_no === "");
            // console.log(index, "index");
            if (index > -1) {
              this.$nextTick(() => {
                this.controlRot[index].person_id = re.data.id;
                this.controlRot[index].id_no = res.IDNumber;
                this.controlRot[index].name = res.Name;
                this.$notification["success"]({
                  message: `${res.Name}培训登记成功`,
                });
              });
            }
          } else {
            this.$error({
              centered: true,
              title: `${res.Name}不在人员系统中`,
              content: "请前往人员信息管理中录入",
              getContainer: () => document.getElementById("bodyContnet"),
            });
          }
        });
        // console.log(JSON.parse(JSON.stringify(res)));
      });
      // 设备状态发生变化
      this.client.setCodeCallback((res) => {
        try {
          if (res.isconnect) {
            this.$message.success("身份证读卡器连接成功");
            if (this.showIdCLose) this.$destroyAll();
            this.showIdCLose = null;
          } else {
            if (this.showIdCLose) return;
            const h = this.$createElement;
            this.showIdCLose = this.$confirm({
              title: "身份证读卡器未连接",
              cancelText: "不再提醒",
              okText: "再次连接",
              getContainer: () => document.getElementById("bodyContnet"),
              content: h("div", {}, [
                h(
                  "p",
                  "1.请将设备插到电脑主板的USB接口上，不要插在USB拓展设备上，并确保设备数据线两端连接稳固。"
                ),
                h("p", "2.笔记本电脑须连接电源才能保障USB接口供电充足"),
              ]),
              onOk: () => {
                this.showIdCLose = null;
              },
              onCancel: () => {},
            });
          }
        } catch (e) {
          console.log(e);
          console.log(res, "异常时返回的数据");
        }
      });
      this.client.setErrorCallback((res) => {
        this.$message.error(res.msg);
      });
      //读卡器本地服务器不在线
      this.client.setCloseCallback(() => {
        this.$error({
          title: "身份证读卡器服务未启动",
          content: "请打开【身份证阅读服务应用程序】或保持在后台",
          getContainer: () => document.getElementById("bodyContnet"),
        });
      });
    },
    //返回平均每题的分数 保留两位小数
    calculateScores(numQuestions, totalScore) {
      const scorePerQuestion = (totalScore / numQuestions).toFixed(2);
      const scores = [];

      for (let i = 0; i < numQuestions - 1; i++) {
        scores.push(parseFloat(scorePerQuestion));
      }

      const lastQuestionScore = (
        totalScore -
        scorePerQuestion * (numQuestions - 1)
      ).toFixed(2);
      scores.push(parseFloat(lastQuestionScore));

      return scores;
    },
    //返回平均每题的分数 保留证书
    calculateScoresZ(numQuestions, totalScore) {
      const scorePerQuestion = Math.floor(totalScore / numQuestions);
      const scores = [];

      for (let i = 0; i < numQuestions - 1; i++) {
        scores.push(scorePerQuestion);
      }

      const lastQuestionScore =
        totalScore - scorePerQuestion * (numQuestions - 1);
      scores.push(lastQuestionScore);

      return scores;
    },
    //获取方案信息
    getInfo() {
      trainProgramInfo(this.id).then((res) => {
        // console.log(res);
        this.name = res.data.name;
        this.classesData = res.data.classesData;
        const defenArr = this.calculateScoresZ(res.data.topicsData.length, 100);
        this.topicsData = res.data.topicsData.map((v, i) => {
          v.fenzhi = defenArr[i];
          return v;
        });
        // console.log("topicsData", JSON.parse(JSON.stringify(this.topicsData)));
        this.bad = res.data.bad;
        this.good = res.data.good;
        this.principal = res.data.principal;
        this.jyr1 = res.data.jyr1;
        this.jyr2 = res.data.jyr2;
        this.jyr3 = res.data.jyr3;
      });
    },
    //录入完成去查看列表页面
    signNext() {
      const no = this.controlRot.filter((v) => !v.id_no);
      if (no.length > 0) {
        this.$confirm({
          centered: true,
          title: `再次确认`,
          content: `还有${no.length}人没有录入`,
          okText: "不录入，进入下一步",
          cancelText: "继续录入",
          getContainer: () => document.getElementById("bodyContnet"),
          onOk: () => {
            this.ing2();
          },
          onCancel: () => {
            this.$refs.procedure1.jianceSelect = true;
          },
        });
      } else {
        this.ing2();
      }
    },
    ing2() {
      this.ing = 2;
      this.client.close();
      this.controlRot = this.controlRot.sort((a, b) => a.iKeyID - b.iKeyID);
    },
    //删除一个答题器
    deleteControlRot(e) {
      this.$confirm({
        centered: true,
        title: `提示`,
        content: `是否确认删除${e.iKeyID}号答题器`,
        okText: "确认删除",
        cancelText: "取消",
        getContainer: () => document.getElementById("bodyContnet"),
        onOk: () => {
          this.controlRot.splice(
            this.controlRot.findIndex((v) => v.iKeyID == e.iKeyID),
            1
          );
          this.$refs.procedure2.getDataByPage();
        },
      });
    },
    //进入培训
    goTrain() {
      this.ing = 3;
    },
    //开始进行培训
    startStudy() {
      //记录当前时间戳
      this.$nextTick(() => {
        this.studyTime = new Date().getTime();
      });
    },
    //开始进行考试
    startExam() {
      //记录当前时间戳
      this.$nextTick(() => {
        this.examTime = new Date().getTime();
      });
    },
    //去考试
    goExamination() {
      this.ing = 4;
      this.startSunVote();
    },
    //开始答题逻辑
    startSunVote() {
      if (this.index == this.topicsData.length - 1) {
        // console.log(JSON.parse(JSON.stringify(this.controlRot)));
        this.is_over = true;
        return this.showGameOver();
      }
      this.index++;
      //给每个人配置试卷模板参数，用于收集答案和配置正确答案，后续直接比较答案
      for (let i = 0; i < this.controlRot.length; i++) {
        let item = this.controlRot[i];
        item.result[this.index] = {
          ...this.topicsData[this.index],
          myanswer: "", //我的答案
        };
      }
      this.$refs.procedure4.init();
      this.startGame(this.topicsData[this.index].type);
    },
    //一道题时间到了
    overonce() {
      this.SunVote.VoteStop2();
      this.checkScore();
      this.startSunVote();
    },
    //给大家打分
    checkScore() {
      const index = this.index;
      for (let i = 0; i < this.controlRot.length; i++) {
        let v = this.controlRot[i];
        // console.log(v.name, v.result[index].myanswer, v.result[index].answer);
        // console.log("分数：", this.topicsData[index].fenzhi);
        if (v.result[index].myanswer === v.result[index].answer) {
          this.$nextTick(() => {
            v.score += this.topicsData[index].fenzhi;
          });
        }
      }
    },
    //考试结束
    showGameOver() {
      this.$refs.gameover.visible = true;
    },
    //签字和指纹完成
    signCallback(e) {
      const index = this.controlRot.findIndex((v) => v.iKeyID == e.id);
      if (index > -1) {
        this.$notification["success"]({
          message: `${this.controlRot[index].name} 签字成功`,
        });
        this.$nextTick(() => {
          this.controlRot[index].sign = e.sign;
          this.controlRot[index].finger = e.finger;
        });
      }
    },
    //数据发送
    sendOver() {
      this.overloading = true;
      console.log(JSON.parse(JSON.stringify(this.controlRot)));
      const studyClass = [];
      for (let i = 0; i < this.controlRot.length; i++) {
        const pitem = this.controlRot[i];
        for (let k = 0; k < this.studyClass.length; k++) {
          if (pitem.person_id) {
            studyClass.push({
              person_id: pitem.person_id,
              ...this.studyClass[k],
            });
          }
        }
      }
      examOver({
        name: this.name,
        bad: this.bad,
        good: this.good,
        studyClass: studyClass,
        studyTime: this.studyTime,
        examTime: this.examTime,
        controlRot: this.controlRot,
        classIds: this.classesData.map((v) => v.id).join(","), //培训id
        classNumber: this.classesData.map((v) => v.id).length, //课时
        jyr1: this.jyr1,
        jyr2: this.jyr2,
        jyr3: this.jyr3,
      })
        .then(() => {
          this.$route.query.ok = 1;
          // this.$message.success("培训已完成");
          this.$notification.success({
            message: "培训已完成",
            description: "培训数据已上传",
          });
          this.$router.history.go(-1);
        })
        .finally(() => {
          let a = setTimeout(() => {
            clearTimeout(a);
            this.overloading = false;
          }, 500);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.title_h {
  font-size: 18px;
  font-weight: bold;
  color: #011733;
  display: flex;
  align-items: center;
}
.title_h span {
  color: #9ba2ab;
  margin-left: 10px;
  font-size: 17px;
  font-weight: 400;
}
</style>